import { useState } from 'react';
import { cars, categories } from '../data/cars';
import CarCard from './CarCard';
import './Fleet.css';

export default function Fleet() {
  const [active, setActive] = useState('Të gjitha');

  const filtered = active === 'Të gjitha'
    ? cars
    : cars.filter(c => c.category === active);

  return (
    <section id="fleet" className="fleet">
      <div className="container">
        <div className="fleet__head">
          <span className="fleet__label">Flota Jonë</span>
          <h2 className="fleet__title">Zgjidhni <em>Makinën</em></h2>
        </div>

        <div className="fleet__filters">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              className={`fleet__filter ${active === cat ? 'fleet__filter--active' : ''}`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="fleet__grid">
          {filtered.map(car => <CarCard key={car.id} car={car} />)}
        </div>
      </div>
    </section>
  );
}